export default {
    notificationsList: (state) => state.notifications.notificationsList,
  };
  